import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import React, { useState } from "react";
import LoadingSpinner from "../LoadingSpinner";
import { useAppSelector } from "../../redux/hooks";
import { useAppDispatch } from "../../redux/hooks";
import Modal from "../Base/Modal";
import { bool } from "yup";
import Card from "../Base/Card";
import SuccessModal from "../SuccessModal";
// import { logoutUser } from "../../redux/auth/authSlice";
// import { FiEye, FiEyeOff, FiX } from "react-icons/fi";
import { ChangePassword } from "../../redux/selfService/selfServiceSlice";

interface PropsI {
  showModal: boolean;
  onClose: () => void;
  item: "email" | "phone";
  onSuccess: () => void;
}

const ChangePasswordModal = ({ onClose, onSuccess, showModal }: PropsI) => {
  const dispatch = useAppDispatch();
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const toggleShowOldPassword = () => setShowOldPassword(!showOldPassword);
  const toggleShowPassword = () => setShowPassword(!showPassword);
  const toggleShowPassword2 = () => setShowPassword2(!showPassword2);
  const toggleShowSuccessModal = () => setShowSuccessModal(!showSuccessModal);

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("Please enter your current password"),
    newPassword: Yup.string()
      .required("Please enter a new password")
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W\_])/,
        "Password must include at least one lowercase letter, one uppercase letter, one digit, and one special character"
      ),
    confirmNewPassword: Yup.string()
      .required("Please retype your new password.")
      .oneOf([Yup.ref("newPassword")], "Passwords must match"),
  });

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (values: any) => {
    setIsLoading(true);
    dispatch(ChangePassword(values))
      .then((res: any) => {
        if (res?.type === 'selfService/ChangePassword/fulfilled' && res.payload?.statusCode === "00") {
          reset(); // Reset form fields
          setShowSuccessModal(true); // Show success modal
          onSuccess(); // Call the success callback
          setIsLoading(false);
        } else {
          setError("Failed to change password. Please try again."); // Handle API error response
          setIsLoading(false);
        }
      })
      .catch((error: any) => {
        setError("Failed to change password. Please try again."); // Handle other errors
        setIsLoading(false);
      });
  };

  return (
    <Modal showModal={showModal} onClose={onClose} className="large-modal">
      <form onSubmit={handleSubmit(onSubmit)} className="w-full">
        <div className="modal-head">
          <div className="flex items-center">Change Temporary Password</div>
        </div>
        <div className="modal-body">
          <Card className="w-full">
            <SuccessModal
              showModal={showSuccessModal}
              onClose={toggleShowSuccessModal}
              note={"Your password has been changed successfully."}
            />
            <div className="mgmt">
              <div className="form__group">
                <label htmlFor="old-password" className="form__label">
                  Temporary Password
                </label>
                <div className="form__input--group">
                  <input
                    id="old-password"
                    type={showOldPassword ? "text" : "password"}
                    className="form__input append"
                    autoComplete="new-password"
                    {...register("oldPassword")}
                  />
                  <div className="append__input">
                    <button
                      type="button"
                      className="btn-text"
                      onClick={toggleShowOldPassword}
                    >
                      {showOldPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>
                {errors.oldPassword && (
                  <span className="text-red-500">
                    {errors.oldPassword.message}
                  </span>
                )}
              </div>
              <div className="form__group">
                <label htmlFor="new-password" className="form__label">
                  New Password
                </label>
                <div className="form__input--group">
                  <input
                    id="new-password"
                    type={showPassword ? "text" : "password"}
                    className="form__input append"
                    {...register("newPassword")}
                  />
                  <div className="append__input">
                    <button
                      type="button"
                      className="btn-text"
                      onClick={toggleShowPassword}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>
                {errors.newPassword && (
                  <span className="text-red-500">
                    {errors.newPassword.message}
                  </span>
                )}
              </div>
              <div className="form__group">
                <label htmlFor="confirm-new-password" className="form__label">
                  Confirm New Password
                </label>
                <div className="form__input--group">
                  <input
                    id="confirm-new-password"
                    type={showPassword2 ? "text" : "password"}
                    className="form__input append"
                    {...register("confirmNewPassword")}
                  />
                  <div className="append__input">
                    <button
                      type="button"
                      className="btn-text"
                      onClick={toggleShowPassword2}
                    >
                      {showPassword2 ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>
                {errors.confirmNewPassword && (
                  <span className="text-red-500">
                    {errors.confirmNewPassword.message}
                  </span>
                )}
              </div>
              <div className="mt-4">
                <button
                  type="submit"
                  className="btn btn-primary w-full"
                  disabled={isLoading}
                >
                  {isLoading ? "Submitting..." : "Confirm"}
                </button>
              </div>
              {error && <div className="mt-4 text-red-500">{error}</div>}
            </div>
          </Card>
        </div>
      </form>
    </Modal>
  );
};

export default ChangePasswordModal;

// const ChangePasswordModal = ({ item, onClose, onSuccess, showModal }: PropsI)=>{
//     const dispatch = useAppDispatch();

//     const [showOldPassword, setShowOldPassword] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);
//     const [showPassword2, setShowPassword2] = useState(false);
//     const [showSuccessModal, setShowSuccessModal] = useState(false)

//     const toggleShowOldPassword = () => setShowOldPassword(!showOldPassword);
//     const toggleShowPassword = () => setShowPassword(!showPassword);
//     const toggleShowPassword2 = () => setShowPassword2(!showPassword2);
//     const toggleShowSuccessModal = () => setShowSuccessModal(!showSuccessModal)
//     const { isLoading, isSuccessful } = useAppSelector((state) => state?.selfService);

//     const [error, setError] = useState<string | null>(null); // Track error message

//     // Clear error message when input text changes
//   const onInputChange = () => {
//     setError(null);
//   };

//   const isPasswordComplex = (password) => {
//     const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\S]{8,40}$/;
//     return passwordRegex.test(password);
//   };

//   const validationSchema = Yup.object().shape({
//     oldPassword: Yup.string().required("Please enter temporary password"),
//     newPassword: Yup.string()
//       .required("Please enter new password")
//       .test({
//         name: 'is-complex',
//         message: 'Password must contain at least 8 characters, one lowercase letter, one uppercase letter, and one digit.',
//         test: (value) => isPasswordComplex(value),
//       }),
//     confirmNewPassword: Yup.string()
//       .required('Please retype your password.')
//       .oneOf([Yup.ref('newPassword')], 'Passwords must match'),
//   });

//     const defaultValues = {
//         oldPassword: "",
//         newPassword: "",
//         confirmNewPassword: "",
//     }

//     const { handleSubmit, register, reset, formState: { errors },} = useForm({
//         resolver: yupResolver(validationSchema),
//         defaultValues
//     });

//     const onSubmit = (values: any)=>{
//         dispatch(ChangePassword(values)).then(res => {
//             if (res?.type === 'selfService/ChangePassword/fulfilled'  && res.payload?.statusCode === "00") {
//                 reset(defaultValues)
//              //  dispatch( logoutUser());
//              onSuccess();
//             }
//         })
//     }

//     return (
//         <Modal showModal={showModal} onClose={onClose} className="large-modal" >

// <div className="modal-head">
//                             <div className="flex items-center">
//                                 Change Temporary Password
//                             </div>
//                             {/* <button className="btn btn-text" onClick={onClose}>
//                                 <FiX className="text-3xl" />
//                             </button> */}
//                             <label htmlFor="branch" className="form__label">
//             To be able to proceed to login, you have to change your default password
//             .{" "}

//           </label>
//                         </div>
//                         <div className="modal-body">
//         <Card className="w-full">
//             <SuccessModal
//                 showModal={showSuccessModal}
//                 onClose={toggleShowSuccessModal}
//                 note={"Your password has been changed successfully."}
//             />

//             <div className="mgmt">
// {/*
//             <div className="form__head mb-8">
//                 Manage your password
//             </div> */}
//             <div className="form__group">
//                 <label htmlFor="old-password" className="form__label">Temporary Password</label>
//                 <div className="form__input--group">
//                     <input
//                         id="old-password"
//                         placeholder="Enter temporary password"
//                         type={ showOldPassword ? 'text' : 'password'}
//                         className="form__input append"
//                         autoComplete="new-password"
//                         {...register("oldPassword")}
//                     />
//                     <div className="append__input">
//                         <button className="btn-text" onClick={toggleShowOldPassword}>
//                             { !showOldPassword ?
//                                 <FiEye className="text-xl" />
//                                 : <FiEyeOff className="text-xl" />
//                             }
//                         </button>
//                     </div>
//                 </div>
//                 {errors.oldPassword && (
//                     <ErrorViewer message={errors.oldPassword.message as string}/>
//                 )}
//             </div>
//             <div className="form__group">
//                 <label htmlFor="new-password" className="form__label">New Password</label>
//                 <div className="form__input--group">
//                     <input
//                         placeholder="Enter new password"
//                         id="new-password"
//                         type={ showPassword ? 'text' : 'password'}
//                         className="form__input append"
//                         {...register("newPassword")}
//                     />
//                     <div className="append__input">
//                         <button className="btn-text" onClick={toggleShowPassword}>
//                             { !showPassword ?
//                                 <FiEye className="text-2xl" />
//                                 : <FiEyeOff className="text-2xl" />
//                             }
//                         </button>
//                     </div>
//                 </div>
//                 {errors.newPassword && (
//                     <ErrorViewer message={errors.newPassword.message as string}/>
//                 )}
//             </div>
//             <div className="form__group">
//                 <label htmlFor="confirm-new-password" className="form__label">Confirm New Password</label>
//                 <div className="form__input--group">
//                     <input
//                         placeholder="Enter new password"
//                         id="confirm-new-password"
//                         type={ showPassword2 ? 'text' : 'password'}
//                         className="form__input append"
//                         {...register("confirmNewPassword")}
//                     />
//                     <div className="append__input">
//                         <button className="btn-text" onClick={toggleShowPassword2}>
//                             { !showPassword2 ?
//                                 <FiEye className="text-2xl" />
//                                 : <FiEyeOff className="text-2xl" />
//                             }
//                         </button>

//                     </div>
//                 </div>
//                 {errors.confirmNewPassword && (
//                     <ErrorViewer message={errors.confirmNewPassword.message as string}/>
//                 )}
//             </div>
//             <div className="mt-4">
//                 <button className="btn btn-primary w-full" onClick={handleSubmit(onSubmit)}>
//                     {isLoading ? <LoadingSpinner /> : "Confirm"}
//                 </button>
//             </div>

//             </div>
//         </Card>
//         </div>
//         </Modal>
//     );
// }
